import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Button,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import Table from "../../Components/Subscription/Table";
import AddSubscription from "../../Components/Subscription/AddSubscription";
import { MdAdd } from "react-icons/md";
import EditSubscription from "../../Components/Subscription/EditSubscription";

// const testSubscriptionData = [
//   {
//     id: 1,
//     name: "Rahul Sharma",
//     mobile: "9876543210",
//     amount: "₹999",
//     status: 1,
//     link: "https://example.com/rahul",
//   },
//   {
//     id: 2,
//     name: "Amit Kumar",
//     mobile: "9876543211",
//     amount: "₹1499",
//     status: 2,
//     link: "https://example.com/amit",
//   },
//   {
//     id: 3,
//     name: "Priya Singh",
//     mobile: "9876543212",
//     amount: "₹1999",
//     status: 1,
//     link: "https://example.com/priya",
//   },
//   {
//     id: 4,
//     name: "Vikas Verma",
//     mobile: "9876543213",
//     amount: "₹799",
//     status: 4,
//     link: "https://example.com/vikas",
//   },
//   {
//     id: 5,
//     name: "Neha Gupta",
//     mobile: "9876543214",
//     amount: "₹2499",
//     status: 1,
//     link: "https://example.com/neha",
//   },
//   {
//     id: 6,
//     name: "Rohit Singh",
//     mobile: "9876543215",
//     amount: "₹999",
//     status: 2,
//     link: "https://example.com/rohit",
//   },
//   {
//     id: 7,
//     name: "Anjali Sharma",
//     mobile: "9876543216",
//     amount: "₹1599",
//     status: 1,
//     link: "https://example.com/anjali",
//   },
//   {
//     id: 8,
//     name: "Suresh Kumar",
//     mobile: "9876543217",
//     amount: "₹699",
//     status: 4,
//     link: "https://example.com/suresh",
//   },
//   {
//     id: 9,
//     name: "Pooja Yadav",
//     mobile: "9876543218",
//     amount: "₹1299",
//     status: 1,
//     link: "https://example.com/pooja",
//   },
//   {
//     id: 10,
//     name: "Manish Jain",
//     mobile: "9876543219",
//     amount: "₹1899",
//     status: 2,
//     link: "https://example.com/manish",
//   },
// ];
const Subscription = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [addSubscription, setAddSubscription] = useState(false);
  const [editDetail, setEditDetail] = useState(false);
  const [fetchData, setFetchData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState("");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const { t } = useTranslation();

  const initialValues = {
    name: "",
    payuKey: "",
    payuMid: "",
    email: "",
    clintId: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);

    return await axios.post(`${Config.apiUrl}/getsubscription`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getSubscriptionSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) {
      error = true;
    } else setFetchData(res.data.data);
  };

  const getSubscriptionError = (res) => {};

  const {
    isLoading: isLoadings,
    mutate: getSubscriptionMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSubscriptionSuccess,
    onError: getSubscriptionError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getSubscriptionMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getSubscriptionMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };

//-------------------Add Subscription-------------------------------
  const addSubscriptionfunction = async (values) => {
      const formData = new FormData();
      formData.append("clientId", values.clientId)
      formData.append("amount", values.amount);
      formData.append("plan", values.plan);
      formData.append("startDate", values.startDate);
      formData.append("nextBillingDue", values.nextBillingDue);
      return await axios.post(`${Config.apiUrl}/addsubscription`, formData, {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "multipart/form-data",
        },
      });
    };

    const onAddSubscriptionSuccess = (data) => {
      if (data?.data?.status === "OK") {
        toast.success(data?.data?.msg || "Add Subscription successfully!");
      } else {
        toast.error(data?.data?.msg || "An error occurred.");
      }
      getSubscriptionMutate();
      setAddSubscription(false);
      setSelectedData("");
    };

    const onAddSubscriptionError = (error) => {
      toast.error(error?.response?.data?.msg || "An error occurred.");
      setAddSubscription(false);
    };
    const { isLoading: isSubscriptionLoading, mutate: addSubscriptionMutate } = useMutation(
      addSubscriptionfunction,
      {
        onSuccess: onAddSubscriptionSuccess,
        onError: onAddSubscriptionError,
      },
    );

//---------------Edit Subscription--------------------------------------------------
  const EditSubscriptionFunction = async (values) => {
    const body = new FormData();
    body.append("id", selectedData?.id);
    body.append("clientId", values.clientId);
    body.append("amount", values.amount);
    body.append("plan", values.plan);
    body.append("startDate", values.startDate);
    body.append("nextBillingDue", values.nextBillingDue);
    body.append("status", values.status);
    body.append("paymentLink", values.paymentLink);
    body.append("gracePeriod", values.gracePeriod);
    body.append("isGSTInvoice", values.isGSTInvoice);
    body.append("showRestrictionToStaff", values.showRestrictionToStaff);
    return await axios.post(`${Config.apiUrl}/editsubscription`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditSuccess = (data) => {
    if (data?.data?.status == "OK") {
      toast.success(data?.data?.msg || "Success");
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setEditDetail(false);
    getSubscriptionMutate();
    setFetchData(data?.data?.data);
  };
  const onEditError = (data) => {
    setSelectedData("");
    setEditDetail(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };
  const { isLoading: editLoading, mutate: editMutate } = useMutation(
    EditSubscriptionFunction,
    {
      onSuccess: onEditSuccess,
      onError: onEditError,
    },
  );


  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Subscriptions")}</Title>
              <Underline />
            </div>
            <UploadWrapper>
              <Button type="button" onClick={() => setAddSubscription(true)}>
                <MdAdd className="text-white w-5 h-5" />{" "}
                <p className="text-sm">{"Add Subscription"}</p>
              </Button>
            </UploadWrapper>
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoadings}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              setIsFilterOpen={setIsFilterOpen}
              setAdvancedFilter={setAdvancedFilter}
              t={t}
            />
          </div>

          {addSubscription && (
            <AddSubscription 
              setAddSubscription={setAddSubscription}
              selectedData={selectedData}
              isSubscriptionLoading={isSubscriptionLoading}
              addSubscriptionMutate={addSubscriptionMutate}
            />
          )}

          {editDetail && (
            <EditSubscription
              editMutate={editMutate}
              editLoading={editLoading}
              setEditDetail={setEditDetail}
              data={data?.data}
              selectedData={selectedData}
            />
          )}


          {!error && !isLoadings && data &&(
            <TableWrapper>
              <Table
                ApiData={fetchData || []}
                setSelectedData={setSelectedData}
                setEditDetail={setEditDetail}
                selectedData={selectedData}
                userType={user.userType}
              />
              {(error || data?.data?.msg === "No data found") && !isLoadings && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoadings || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  setIsFilterOpen,
  setAdvancedFilter,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>
          <div className="flex gap-3 items-end flex-wrap">
            {filter !== "status" && filter !== "paymentMode" ? (
              <InputGroup className="w-[200px]">
                <Field
                  className="border border-gray-300 rounded-md px-3 h-10 w-full focus:ring-1 focus:ring-primary-color focus:border-primary-color"
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile" || filter === "clientId") {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                />
              </InputGroup>
            ) : null}

            <InputGroup className="" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                  setAdvancedFilter("");
                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="mobile">Phone</MenuItem>
                <MenuItem value="clientId">Client Id</MenuItem>
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;

export default Subscription;
